import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'

function InventoryListPage() {
  return (
    <AppLayout>
        <div>InventoryListPage</div>
    </AppLayout>
  )
}

export default InventoryListPage